const initialState = { supplements: null, fetchedDate: null };

const supplementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_SUPPLEMENTS": {
      const { data } = action;

      let memberships = state.supplements || []
      let dates = state.fetchedDate || []
      data.map((membership) => {
        if (!dates.find((date) => date === membership.date)) {
          const newMembers = data.filter(a => a.date === membership.date)
          memberships = memberships.concat(newMembers)
          dates.push(membership.date)
        }
      })

      return {
        ...state,
        supplements: memberships,
        fetchedDate: dates
      }
    };

    case "CREATE_SUPPLEMENT": {
      let dt = state.supplements.concat(action.data);
      return {
        ...state,
        supplements: dt,
      };
    }
    case "UPDATE_SUPPLEMENT": {
      let dt = state.supplements.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        supplements: dt,
      };
    }
    case "DELETE_SUPPLEMENT": {
      let dt = state.supplements.filter((a) => a._id !== action.data);
      return {
        ...state,
        supplements: dt,
      };
    }
    default:
      return state;
  }
};

export default supplementsReducer;
